<div class="header">
  <app-icon class="warning" name="warning"></app-icon>
  <p><b>Brak połączenia z internetem</b></p>
</div>
<button (click)="onClose()">
  <app-icon name="close"></app-icon>
</button>
